import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  flex-shrink: 0;\n  margin: 0 auto 18px;\n  max-width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " auto 18px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { ConfirmationModal } from '@scp/ui-shared/components/modals';
import { Loader } from '@scp/ui-shared/components';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { FileIcon } from './FileIcon';
import { isImage, parseFileSize } from './utils';
var TEXT = {
  TITLE: function TITLE(fileUploadToTitle) {
    return fileUploadToTitle ? "Upload a file to ".concat(fileUploadToTitle, "?") : 'Upload a file?';
  }
};
var Wrapper = styled.div(_templateObject());
var IconWrapper = styled.div(_templateObject2(), baselineToPx(2));
var Image = styled.img(_templateObject3());
var FileProperty = styled(Paragraph).attrs({
  as: 'span',
  secondary: true,
  noMargin: true
})(_templateObject4(), ellipsis());
export var UploadConfirmModal = function UploadConfirmModal(_ref) {
  var file = _ref.file,
      fileUploadToTitle = _ref.fileUploadToTitle,
      onCancel = _ref.onCancel,
      onAccept = _ref.onAccept,
      acceptLabel = _ref.acceptLabel;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      imagePreviewUri = _useState2[0],
      setImagePreviewUri = _useState2[1];

  useEffect(function () {
    if (!imagePreviewUri) setPreviewUri();
  });

  var setPreviewUri = function setPreviewUri() {
    if (file && isImage(file.type)) {
      var reader = new FileReader();

      reader.onloadend = function () {
        setImagePreviewUri(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  var cancel = function cancel() {
    onCancel();
    setImagePreviewUri(null);
  };

  var accept = function accept() {
    onAccept();
    setImagePreviewUri(null);
  };

  var renderPreview = function renderPreview() {
    var type = file.type,
        name = file.name;

    if (isImage(type)) {
      if (!imagePreviewUri) return React.createElement(Loader, null);
      return React.createElement(Image, {
        src: imagePreviewUri,
        alt: name,
        title: name
      });
    }

    return React.createElement(IconWrapper, null, React.createElement(FileIcon, {
      mimeType: type,
      size: 80
    }));
  };

  return React.createElement(ConfirmationModal, {
    open: !!file,
    title: TEXT.TITLE(fileUploadToTitle),
    onCancel: cancel,
    onAccept: accept,
    acceptLabel: acceptLabel,
    wide: true,
    narrow: false,
    noPaperPadding: true
  }, !!file && React.createElement(Wrapper, null, renderPreview(), React.createElement(FileProperty, {
    title: file.name
  }, file.name), React.createElement(FileProperty, {
    title: parseFileSize(file.size)
  }, parseFileSize(file.size))));
};